<app-header [showToggle]="false" [showSignin]="false"></app-header>
<main id="main" class="main">

  <section class="section dashboard">
    <div class="pagetitle text-center">
      <h1>Website Title Checker</h1>
      <div class="div-page-description"><h5>Boost your SEO game with our Website Title Checker. Optimize titles instantly for search engine rankings.</h5></div>
    </div>
    <div class="container">
      <div class="row">

        <div class="col-lg-11 col-9">
          <form class="form-inline">
            <div class="input-group mb-3">
              <span class="input-group-text" id="basic-addon3">https://</span>

              <input class="form-control" type="search" placeholder="Enter URL without https or http" aria-label="Search" name="url" [(ngModel)]="url" aria-describedby="basic-addon3">
            </div>
          </form>
        </div>
        <div class="col-lg-1 col-3">
          <app-spinner *ngIf="showCheckSeoModalSpinner"></app-spinner>
          <button class="btn btn-primary" type="submit" *ngIf="!showCheckSeoModalSpinner" (click)="checkTitle()">Check</button>
        </div>
      </div>

      <div class="row mt-3" *ngIf="seoResults!=null">

        <div class="col-lg-12">
          <span *ngIf="seoResults.title!=null">
            <i *ngIf="seoResults.title!=null && (seoResults.title.length>49 && seoResults.title.length<61)" class="bi bi-check-circle-fill text-success"></i>
            <i *ngIf="seoResults.title!=null && (seoResults.title.length<50 || seoResults.title.length>60)" class="bi bi-exclamation-circle-fill text-warning"></i>
            Title found.
            <span *ngIf="seoResults.title.length<50 || seoResults.title.length>60">Make sure your titles are well-written and interesting, keeping them between 50 and 60 characters.</span>
          </span>
          <span *ngIf="seoResults.title==null"><i class="bi bi-x-circle-fill text-danger"></i> Title not found.</span>

          <div class="alert alert-info show mt-2" role="alert" *ngIf="seoResults.title!=null">

            <b>Title:</b> {{seoResults.title}} <br />
            <b>Length:</b> {{seoResults.title.length}}
          </div>
        </div>
      </div>

      <div class="row mt-3">

        <div class="col-lg-12">

          <div class="accordion accordion-flush" id="faq-group-1">
            <div class="accordion-item">
              <h2 class="accordion-header">
                <button class="accordion-button collapsed" data-bs-target="#faqs-1" type="button" data-bs-toggle="collapse" aria-expanded="false">
                  About Website Title Checker Tool
                </button>
              </h2>
              <div id="faqs-1" class="accordion-collapse collapse" data-bs-parent="#faq-group-1" style="">
                <div class="accordion-body">
                  <p>In the ever-evolving landscape of online presence, the significance of SEO cannot be overstated. It's the magic wand that boosts visibility and propels your website to the forefront of search engine results. At the heart of this SEO magic lies a seemingly small yet mighty element – the website title. In this blog post, we'll explore the vital role of the website title and introduce you to a game-changing tool: the Website Title Checker.</p>
                </div>
              </div>
            </div>
            <div class="accordion-item">
              <h2 class="accordion-header">
                <button class="accordion-button collapsed" data-bs-target="#faqs-2" type="button" data-bs-toggle="collapse" aria-expanded="false">
                  Why is the Title of a Web Page Important in Terms of SEO?
                </button>
              </h2>
              <div id="faqs-2" class="accordion-collapse collapse" data-bs-parent="#faq-group-1" style="">
                <div class="accordion-body">
                  <p>Your website's title is the first impression it makes on search engines and users alike. It serves as a succinct preview of what your page is all about, influencing the click-through rate and overall user experience. Search engines use the title to understand the content of your page, making it a critical factor for ranking. The Website Title Checker tool becomes your ally in ensuring that this crucial element is not just present but optimized for maximum impact.</p>
                  <p>In a world where attention spans are shorter than ever, a compelling and SEO-friendly title can be the difference between being scrolled over or clicked on. With the Website Title Checker, you can analyze and fine-tune your titles to perfection, aligning them with the best practices of SEO.</p>
                </div>
              </div>
            </div>
            <div class="accordion-item">
              <h2 class="accordion-header">
                <button class="accordion-button collapsed" data-bs-target="#faqs-3" type="button" data-bs-toggle="collapse" aria-expanded="false">
                  What is the Best Title Length for SEO?
                </button>
              </h2>
              <div id="faqs-3" class="accordion-collapse collapse" data-bs-parent="#faq-group-1" style="">
                <div class="accordion-body">
                  <p>Finding the Goldilocks zone for your title length is a balancing act. Too short, and you might miss out on conveying essential information; too long, and you risk diluting your SEO effectiveness. The Website Title Checker tool takes the guesswork out of this equation. It provides insights into the optimal title length, ensuring that your titles are concise, impactful, and within the SEO sweet spot.</p>
                  <p>Active voice plays a crucial role here – the tool actively checks and suggests improvements, empowering you to craft titles that resonate with both search engines and your target audience.</p>
                </div>
              </div>
            </div>
            <div class="accordion-item">
              <h2 class="accordion-header">
                <button class="accordion-button collapsed" data-bs-target="#faqs-4" type="button" data-bs-toggle="collapse" aria-expanded="false">
                  What is the Best Title Length for SEO?
                </button>
              </h2>
              <div id="faqs-4" class="accordion-collapse collapse" data-bs-parent="#faq-group-1" style="">
                <div class="accordion-body">
                  <p>Crafting an SEO-friendly title is an art. It involves incorporating relevant keywords, conveying the essence of your content, and enticing users to click. The Website Title Checker tool simplifies this process by offering real-time analysis and suggestions. Active voice becomes your guide as you navigate the intricacies of SEO title creation.</p>
                  <p>In conclusion, the Website Title Checker tool is your companion on the journey to SEO excellence. It transforms the seemingly simple task of checking website titles into a strategic move for boosting your online presence.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</main>
<app-alert [showMessage]="showMessage" [message]="message" [alertType]="alertType">
</app-alert>
<app-footer></app-footer>

<a id="btn-back-to-top" class="back-to-top d-flex align-items-center justify-content-center"><i class="bi bi-arrow-up-short"></i></a>
